import type { AttendanceToday } from '@/features/attendance/types/attendance.types'

export function getLiveElapsedSeconds(
  attendance: AttendanceToday | null | undefined,
  nowMs: number,
  serverTime?: string,
): number {
  if (!attendance) return 0

  const baseSeconds = attendance.elapsedSeconds ?? 0
  if (!attendance.isActive || attendance.isOnBreak || !serverTime) {
    return baseSeconds
  }

  const serverMs = new Date(serverTime).getTime()
  if (!Number.isFinite(serverMs)) return baseSeconds

  const liveSeconds = Math.max(0, Math.floor((nowMs - serverMs) / 1000))
  return baseSeconds + liveSeconds
}
